import React from 'react';
import { PropTypes } from 'prop-types';
import Question from '../../question';
import { ActionLink, TaskSegment } from '../styles';

const QuestionSegment = ({
  index,
  task,
  setIsUploadDone,
  errors,
  handleRemoveQuestion,
  touched,
  isEdit,
  hideTrashCan,
  setFieldValue,
  onClickDuplicate,
  onChangeUrl,
  taskIndex,
  testType,
}) => {
  const { questionType } = task;

  return (
    <TaskSegment isEdit={isEdit.toString()}>
      {!hideTrashCan && (
        <>
          <ActionLink
            onClick={() => handleRemoveQuestion(index)}
          >
            Delete
          </ActionLink>

          {questionType !== 'image_select' && questionType !== 'audio_video' && (
            <ActionLink
              onClick={() => onClickDuplicate(index)}
            >
              Duplicate
            </ActionLink>
          )}
        </>
      )}

      <Question
        isEdit={isEdit}
        question={task}
        index={index}
        errors={errors}
        touched={touched}
        setFieldValue={setFieldValue}
        onChangeUrl={onChangeUrl}
        taskIndex={taskIndex}
        testType={testType}
        onSetIsUploadDone={setIsUploadDone}
      />
    </TaskSegment>
  );
};

QuestionSegment.propTypes = {
  index: PropTypes.number.isRequired,
  task: PropTypes.object.isRequired,
  setIsUploadDone: PropTypes.func,
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  touched: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  handleRemoveQuestion: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  hideTrashCan: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onClickDuplicate: PropTypes.func.isRequired,
  onChangeUrl: PropTypes.func,
  taskIndex: PropTypes.number.isRequired,
  testType: PropTypes.string.isRequired,
};

QuestionSegment.defaultProps = {
  setIsUploadDone: null,
  onChangeUrl: null,
};

export default QuestionSegment;
